export default __webpack_public_path__ + "static/media/nelson-mandela.36fe2fd8.png";